import { TagColorScheme, TagSize } from "@ui-kit/data-display/Tag/Tag.props";

export const getSizeProps = (size: TagSize) => {
  switch (size) {
    case "lg":
      return {
        minHeight: "28px",
        height: "28px",
        fontSize: "14px",
        lineHeight: "17px",
      };
    case "md":
      return {
        minHeight: "24px",
        height: "24px",
        fontSize: "14px",
        lineHeight: "17px",
      };
    case "sm":
    default:
      return {
        minHeight: "22px",
        height: "22px",
        fontSize: "12px",
        lineHeight: "16px",
      };
  }
};

export const getColorProps = (colorPalette: TagColorScheme) => {
  switch (colorPalette) {
    case "success":
      return {
        backgroundColor: "green.200",
        color: "green.900",
      };
    case "warning":
      return {
        backgroundColor: "yellow.200",
        color: "yellow.900",
      };
    case "error":
      return {
        backgroundColor: "red.200",
        color: "red.900",
      };
    case "blue":
      return {
        backgroundColor: "blue.200",
        color: "blue.900",
      };
    case "indigo":
      return {
        backgroundColor: "indigo.200",
        color: "indigo.900",
      };
    case "pink":
      return {
        backgroundColor: "pink.200",
        color: "pink.900",
      };
    case "purple":
      return {
        backgroundColor: "purple.200",
        color: "purple.900",
      };
    case "primary":
      return {
        backgroundColor: "primary.200",
        color: "primary.900",
      };
    case "secondary":
      return {
        backgroundColor: "secondary.200",
        color: "secondary.900",
      };
    case "gray":
    default:
      return {
        backgroundColor: "gray.200",
        color: "gray.900",
      };
  }
};
